const WebPageSchema = ({
  name,
  description,
  url
}) => ({
  "@type": "WebPage",
  "@id": `${url}#webpage`,
  "url": url,
  "name": name,
  "description": description,
  "isPartOf": {
    "@id": "https://onbbits.io/#website"
  },
  "about": {
    "@id": "https://onbbits.io/#organization"
  }
});

export default WebPageSchema;